import {PostOfficeProvider as $6be305b678e52aff$re_export$PostOfficeProvider, usePostOfficeEnvironment as $aNxVi$usePostOfficeEnvironment, useStableObject as $aNxVi$useStableObject} from "@atlassian/post-office-context";
import {jsx as $aNxVi$jsx} from "react/jsx-runtime";
import {Placement as $aNxVi$Placement} from "@atlassian/post-office-placement-shared";
import {RemoteComponent as $aNxVi$RemoteComponent} from "@atlassian/remote-module-loader/remote-component";
import {PluginName as $aNxVi$PluginName, ExternalModuleName as $aNxVi$ExternalModuleName} from "@atlassian/remote-module-loader/types";
import $aNxVi$memoizeone from "memoize-one";
import {version as $aNxVi$version} from "react";
import * as $aNxVi$atlassiansoxcrossflowsupport from "@atlassiansox/cross-flow-support";
import * as $aNxVi$atlassianufosegment from "@atlassian/ufo-segment";
import * as $aNxVi$atlassianufoloadhold from "@atlassian/ufo-load-hold";





const $62ec8f41f780f803$export$85183a312807388d = 'postOffice';





const $b4a9fb0f456a4662$var$VARIANT_LATEST = 'latest';
class $b4a9fb0f456a4662$var$RemotePostOfficePlugin {
    constructor(placementId, environmentContext){
        this.name = (0, $aNxVi$PluginName).PostOffice;
        this.moduleUriMapper = (0, $aNxVi$memoizeone)((uri, variant = $b4a9fb0f456a4662$var$VARIANT_LATEST, computeHash)=>{
            // The goal here is to take a version string of the form "18.1.2"
            // and get only the major version part.
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            const reactMajorVersion = (0, $aNxVi$version).split('.')[0];
            // We want to hash the major version of React installed, alongside the chosen variant
            const hashedDependencies = [
                'react',
                'react-dom'
            ];
            const hashedValues = hashedDependencies.reduce((mappings, dependency)=>mappings.concat([
                    {
                        name: dependency,
                        version: reactMajorVersion
                    }
                ]), []);
            const hash = computeHash(variant, hashedValues);
            return `${uri}.${hash}.js`;
        });
        this.placementId = placementId;
        const { currentEnv: currentEnv, envConfigs: envConfigs } = environmentContext;
        const mapPlacementEnvToRMLEnv = (placementEnv)=>{
            return ({
                local: 'local',
                test: 'test',
                dev: 'local',
                staging: 'staging',
                production: 'production',
                'stg-fedm-east': 'staging',
                'prod-fedm-east': 'production'
            })[placementEnv];
        };
        this._dimensions = {
            env: mapPlacementEnvToRMLEnv(currentEnv),
            variant: $b4a9fb0f456a4662$var$VARIANT_LATEST
        };
        this._manifestMap = new Map([
            [
                'local',
                new Map([
                    [
                        $b4a9fb0f456a4662$var$VARIANT_LATEST,
                        {
                            moduleName: $b4a9fb0f456a4662$var$MODULE_NAME,
                            moduleUri: `${envConfigs.local.remoteModule.origin}/${placementId}`,
                            externals: $b4a9fb0f456a4662$var$EXTERNALS
                        }
                    ]
                ])
            ],
            [
                'test',
                new Map([
                    [
                        $b4a9fb0f456a4662$var$VARIANT_LATEST,
                        {
                            moduleName: $b4a9fb0f456a4662$var$MODULE_NAME,
                            moduleUri: `${envConfigs.test.remoteModule.origin}/${placementId}`,
                            externals: $b4a9fb0f456a4662$var$EXTERNALS
                        }
                    ]
                ])
            ],
            [
                'staging',
                new Map([
                    [
                        $b4a9fb0f456a4662$var$VARIANT_LATEST,
                        {
                            moduleName: $b4a9fb0f456a4662$var$MODULE_NAME,
                            moduleUri: `${envConfigs.staging.remoteModule.origin}/${placementId}`,
                            externals: $b4a9fb0f456a4662$var$EXTERNALS
                        }
                    ]
                ])
            ],
            [
                'production',
                new Map([
                    [
                        $b4a9fb0f456a4662$var$VARIANT_LATEST,
                        {
                            moduleName: $b4a9fb0f456a4662$var$MODULE_NAME,
                            moduleUri: `${envConfigs.production.remoteModule.origin}/${placementId}`,
                            externals: $b4a9fb0f456a4662$var$EXTERNALS
                        }
                    ]
                ])
            ]
        ]);
    }
    get dimensions() {
        return this._dimensions;
    }
    get manifestMap() {
        return this._manifestMap;
    }
    get bifrostOverrideKey() {
        return `${this.placementId}-bifrost-override`;
    }
}
const $b4a9fb0f456a4662$var$MODULE_NAME = '@atlassian/post-office-placement-remote';



const $b4a9fb0f456a4662$var$EXTERNALS = [
    {
        name: (0, $aNxVi$ExternalModuleName).React
    },
    {
        name: (0, $aNxVi$ExternalModuleName).ReactDOM
    },
    {
        name: (0, $aNxVi$ExternalModuleName).ReactIntlNext
    },
    {
        name: (0, $aNxVi$ExternalModuleName).EmotionReact
    },
    {
        name: (0, $aNxVi$ExternalModuleName).FeatureGateJsClientPublic
    },
    {
        module: '@atlassiansox/cross-flow-support',
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        import: $aNxVi$atlassiansoxcrossflowsupport,
        isDefault: false
    },
    {
        module: '@atlassian/ufo-segment',
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        import: $aNxVi$atlassianufosegment,
        isDefault: true
    },
    {
        module: '@atlassian/ufo-load-hold',
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        import: $aNxVi$atlassianufoloadhold,
        isDefault: true
    }
];
var $b4a9fb0f456a4662$export$2e2bcd8739ae039 = $b4a9fb0f456a4662$var$RemotePostOfficePlugin;


class $8b4aa99c45ca57a2$var$PluginRegistry {
    static getRegistry() {
        if (window.postOfficePluginRegistry === undefined) window.postOfficePluginRegistry = new $8b4aa99c45ca57a2$var$PluginRegistry();
        return window.postOfficePluginRegistry;
    }
    getPluginForPlacement(placementId, environmentContext) {
        const pluginKey = `${placementId}--${environmentContext.currentEnv}`;
        if (this.registry.has(pluginKey)) return this.registry.get(pluginKey);
        const plugin = new (0, $b4a9fb0f456a4662$export$2e2bcd8739ae039)(placementId, environmentContext);
        this.registry.set(pluginKey, plugin);
        return plugin;
    }
    constructor(){
        this.registry = new Map();
    }
}
var $8b4aa99c45ca57a2$export$2e2bcd8739ae039 = $8b4aa99c45ca57a2$var$PluginRegistry;


const $47a838511bf30249$var$STABLE_OBJECT = {};
const $47a838511bf30249$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, Fallback: Fallback, onEvent: onEvent })=>{
    const environmentContext = (0, $aNxVi$usePostOfficeEnvironment)();
    const pluginRegistry = (0, $8b4aa99c45ca57a2$export$2e2bcd8739ae039).getRegistry();
    const plugin = pluginRegistry.getPluginForPlacement(placementId, environmentContext);
    const stableRemotePlacementProps = (0, $aNxVi$useStableObject)(placementProps ?? $47a838511bf30249$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $aNxVi$jsx)((0, $aNxVi$Placement), {
        placementId: placementId,
        consumptionType: "remote",
        onEvent: onEvent,
        children: ({ initialData: initialData, onEvent: onEvent, context: context })=>/*#__PURE__*/ (0, $aNxVi$jsx)((0, $aNxVi$RemoteComponent), {
                analyticsChannel: (0, $62ec8f41f780f803$export$85183a312807388d),
                remotePlugin: plugin,
                onEvent: onEvent,
                ErrorFallback: ErrorFallback,
                Fallback: Fallback,
                initialData: initialData,
                context: context,
                ...stableRemotePlacementProps,
                children: children
            })
    });
};
var $47a838511bf30249$export$2e2bcd8739ae039 = $47a838511bf30249$var$Placement;






export {$47a838511bf30249$export$2e2bcd8739ae039 as Placement, $b4a9fb0f456a4662$export$2e2bcd8739ae039 as RemotePostOfficePlugin, $6be305b678e52aff$re_export$PostOfficeProvider as PostOfficeProvider};
//# sourceMappingURL=index.js.map
